import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CustomInputComponent } from '../../../shared/Inputs/customInput/customInput.component';
import { CustomnumberComponent } from '../../../shared/Inputs/customnumber/customnumber.component';
import { TextareaModule } from 'primeng/textarea';
import { Address } from '../../../shared/interface/address';
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
@Component({
  selector: 'app-add-update',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CustomInputComponent,
    CustomnumberComponent,
    TextareaModule,
    TranslatePipe
  ],
  templateUrl: './add-update.component.html',
})
export class AddUpdateComponent {
  @Input() initialData: Partial<Address> | null = null;
  @Output() formSubmit = new EventEmitter<Partial<Address>>();
  @Output() close = new EventEmitter<void>();
  @Output() citySelected = new EventEmitter<string>();
translateService = inject(TranslateService);
  onClose() {
    this.close.emit();
  }

  selectAddress(address: Address) {
    this.citySelected.emit(address.city);
    this.close.emit();
  }
  formdata = new FormGroup({
    city: new FormControl('', Validators.required),
    street: new FormControl('', Validators.required),
    phone: new FormControl('', Validators.required),
  });

  ngOnChanges() {
    if (this.initialData) {
      this.formdata.patchValue(this.initialData);
    }
  }

  submit() {
    if (this.formdata.valid) {
      this.formSubmit.emit(this.formdata.value as Partial<Address>);
    }
  }
}
